/**
 * jQuery FocusPoint; version: 1.1.3
 * Author: http://jonathonmenz.com
 * Source: https://github.com/jonom/jquery-focuspoint
 * Copyright (c) 2014 J. Menz; MIT License
 * @preserve
 */

(function ($) {
	const defaults = {
		reCalcOnWindowResize: true,
		throttleDuration: 17 // ms - set to 0 to disable throttling
	};

	// Setup a container instance
	const setupContainer = function ($el) {
		const imageSrc = $el.find('img').attr('src');
		$el.data('imageSrc', imageSrc);

		resolveImageSize(imageSrc, (err, dim) => {
			$el.data({
				imageW: dim.width,
				imageH: dim.height
			});
			adjustFocus($el);
		});
	};

	// Get the width and the height of an image
	// by creating a new temporary image
	var resolveImageSize = function (src, cb) {
		// Create a new image and set a
		// handler which listens to the first
		// call of the 'load' event.
		$('<img />').one('load', function () {
			// 'this' references to the new
			// created image
			cb(null, {
				width: this.width,
				height: this.height
			});
		}).attr('src', src);
	};

	// Create a throttled version of a function
	const throttle = function (fn, ms) {
		let isRunning = false;
		return function () {
			const args = Array.prototype.slice.call(arguments, 0);
			if (isRunning) return false;
			isRunning = true;
			setTimeout(() => {
				isRunning = false;
				fn(...args);
			}, ms);
		};
	};

	// Calculate the new left/top values of an image
	const calcShift = function (conToImageRatio, containerSize, imageSize, focusSize, toMinus) {
		const containerCenter = Math.floor(containerSize / 2); // Container center in px
		const focusFactor = (focusSize + 1) / 2; // Focus point of resize image in px
		const scaledImage = Math.floor(imageSize / conToImageRatio); // Can't use width() as images may be display:none
		let focus = Math.floor(focusFactor * scaledImage);
		if (toMinus) focus = scaledImage - focus;
		let focusOffset = focus - containerCenter; // Calculate difference between focus point and center
		const remainder = scaledImage - focus; // Reduce offset if necessary so image remains filled
		const containerRemainder = containerSize - containerCenter;
		if (remainder < containerRemainder) focusOffset -= containerRemainder - remainder;
		if (focusOffset < 0) focusOffset = 0;

		return `${focusOffset * -100 / containerSize}%`;
	};

	// Re-adjust the focus
	var adjustFocus = function ($el) {
		const imageW = $el.data('imageW');
		const imageH = $el.data('imageH');
		const imageSrc = $el.data('imageSrc');

		if (!imageW && !imageH && !imageSrc) {
			return setupContainer($el); // Setup the container first
		}

		const containerW = $el.width();
		const containerH = $el.height();
		const focusX = parseFloat($el.data('focusX'));
		const focusY = parseFloat($el.data('focusY'));
		const $image = $el.find('img').first();

		// Amount position will be shifted
		let hShift = 0;
		let vShift = 0;

		if (!(containerW > 0 && containerH > 0 && imageW > 0 && imageH > 0)) {
			return false; // Need dimensions to proceed
		}

		// Which is over by more?
		const wR = imageW / containerW;
		const hR = imageH / containerH;

		// Reset max-width and -height
		$image.css({
			'max-width': '',
			'max-height': ''
		});

		// Minimize image while still filling space
		if (imageW > containerW && imageH > containerH) {
			$image.css((wR > hR) ? 'max-height' : 'max-width', '100%');
		}

		if (wR > hR) {
			hShift = calcShift(hR, containerW, imageW, focusX);
		} else if (wR < hR) {
			vShift = calcShift(wR, containerH, imageH, focusY, true);
		}

		$image.css({
			top: vShift,
			left: hShift
		});
	};

	const $window = $(window);

	const focusPoint = function ($el, settings) {
		const thrAdjustFocus = settings.throttleDuration ?
			throttle(() => { adjustFocus($el); }, settings.throttleDuration)
			: function () { adjustFocus($el); };// Only throttle when desired
		let isListening = false;

		adjustFocus($el); // Focus image in container

		// Expose a public API
		return {

			adjustFocus() {
				return adjustFocus($el);
			},

			windowOn() {
				if (isListening) return;
				// Recalculate each time the window is resized
				$window.on('resize', thrAdjustFocus);
				return isListening = true;
			},

			windowOff() {
				if (!isListening) return;
				// Stop listening to the resize event
				$window.off('resize', thrAdjustFocus);
				isListening = false;
				return true;
			}

		};
	};

	$.fn.focusPoint = function (optionsOrMethod) {
		// Shortcut to functions - if string passed assume method name and execute
		if (typeof optionsOrMethod === 'string') {
			return this.each(function () {
				const $el = $(this);
				$el.data('focusPoint')[optionsOrMethod]();
			});
		}
		// Otherwise assume options being passed and setup
		const settings = $.extend({}, defaults, optionsOrMethod);
		return this.each(function () {
			const $el = $(this);
			const fp = focusPoint($el, settings);
			// Stop the resize event of any previous attached
			// focusPoint instances
			if ($el.data('focusPoint')) $el.data('focusPoint').windowOff();
			$el.data('focusPoint', fp);
			if (settings.reCalcOnWindowResize) fp.windowOn();
		});
	};

	$.fn.adjustFocus = function () {
		// Deprecated v1.2
		return this.each(function () {
			adjustFocus($(this));
		});
	};
}(jQuery));
